export function cn(...inputs) {
    return [...new Set(inputs.filter(Boolean).join(" ").split(" "))].join(" ");
  }
  